import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    activeNav: '',//状态
  },
  mutations: {
    changeActiveNav(state,d){
      state.activeNav = d ? d : '';
    }
  },
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js